import { render, staticRenderFns } from "./PrtHeader.vue?vue&type=template&id=fb07df7c&"
import script from "./PrtHeader.js?vue&type=script&lang=js&"
export * from "./PrtHeader.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports